// FUTURE CODE:   Filter through items so they can be automated in the future
// const list = document.querySelectorAll(".array-one");
// const itemInList = Object.values(list).filter((item) => (id == item.id && item.checked));
// console.log(id, "<==id, list==>", list, "<===list array-  item in list ==>", itemInList);

// KLAVIYO QUIZ DIRECTS TO MoMoMuscle List: Uqywym


//========>    Quiz Build
const progressBar = document.getElementById("progress-container");
const progress1 = document.getElementById("progress-1");
const progress2 = document.getElementById("progress-2");
const progress3 = document.getElementById("progress-3");
const progress4 = document.getElementById("progress-4");
const progress5 = document.getElementById("progress-5");
const progress6 = document.getElementById("progress-6");
const progress7 = document.getElementById("progress-7");
const progress8 = document.getElementById("progress-8");
const progress9 = document.getElementById("progress-9");
const quizContainer = document.getElementById("quiz-container");  
const quizWindow = document.getElementById("quiz-window");
const quizPagePrograms = document.getElementById("feature-program-quiz");
const mobileQuizHeroShade = document.getElementById("mobile-quiz-hero-shade");

let ResponseOne = [];
let ResponseTwo = [];
let ResponseThree = [];
let ResponseFour = [];
let ResponseFive = [];
let ResponseSix = [];
let ResponseSeven = [];


// Create Previous & Next Arrow toggle
prevNav = ((value, name) => {
  const goFrom = document.getElementById(`quiz-${value}`);
  const goTo = document.getElementById(`quiz-${name}`);

    goFrom.style.opacity = "0";
    goTo.style.display = "flex";
    setTimeout(function() {
      goFrom.style.display = "none",
      goTo.style.opacity = "1";
    }, 500);
});
nextNav = ((value, name) => {
  const goFrom = document.getElementById(`quiz-${value}`);
  const goTo = document.getElementById(`quiz-${name}`);
    goFrom.style.opacity = "0";
    goTo.style.display = "flex";
    setTimeout(function() {
      goFrom.style.display = "none",
      goTo.style.opacity = "1";
    }, 500);

});

arrowNav = ((value) => {
  console.log("arrow nav", value);
});
testFunction = ((value) => {
  console.log("test nav", value);
});

//=======> Event Listeners
startQuiz = (() => {
  const q = document.getElementById("start-quiz");
  const w = document.getElementById("quiz-window");
  const b = document.getElementById("quiz-one");
  q.style.opacity = "0";
  b.style.display = "flex";
  setTimeout(function() {
    w.classList.add("white-form");
    progressBar.style.opacity = 1;
    q.style.display = "none",
    b.style.opacity = "1";
  }, 500);
});
StepONE = (id, value) => {
  const q = document.getElementById("quiz-one");
  const b = document.getElementById("quiz-two");
  const n = document.getElementById("next-one-btn");
  if (id != "one-1" && document.getElementById("one-1").checked ||
      id != "one-2" && document.getElementById("one-2").checked ||
      id != "one-3" && document.getElementById("one-3").checked ||
      id != "one-4" && document.getElementById("one-4").checked ||
      id != "one-5" && document.getElementById("one-5").checked ||
      id != "one-6" && document.getElementById("one-6").checked
     ){ 
    document.getElementById(id).checked = false; 
  } else if (document.getElementById(id).checked) {
    ResponseOne = questionONE.qna[value]; 
    n.disabled = false;
    q.style.opacity = "0";
    b.style.display = "flex";
    setTimeout(function() {
      
      progress1.value = '1';
      q.style.display = "none",
      b.style.opacity = "1";
    }, 500);
  } else {
    n.disabled = true;
    progress1.value = '0';
    
  }
};
StepTWO = (id, value) => {
  const q = document.getElementById("quiz-two");
  const b = document.getElementById("quiz-three");
  const n = document.getElementById("next-two-btn");
  if (id != "two-1" && document.getElementById("two-1").checked ||
      id != "two-2" && document.getElementById("two-2").checked ||
      id != "two-3" && document.getElementById("two-3").checked ||
      id != "two-4" && document.getElementById("two-4").checked ){ 
    document.getElementById(id).checked = false; 
  } else if (document.getElementById(id).checked) {
    ResponseTwo = questionTWO.qna[value]; 
    n.disabled = false;
    q.style.opacity = "0";
    b.style.display = "flex";
    setTimeout(function() {
      
      progress2.value = '1';
      q.style.display = "none",
      b.style.opacity = "1";
    }, 500);
  } else {
    n.disabled = true;
    progress2.value = '0';
  }
};

btnThree = () => {
  var StepThreeList = [];
  const q = document.getElementById("quiz-three");
  const b = document.getElementById("quiz-four");
  const list = document.querySelectorAll(".step-three");
  if (list){
    for (i = 0; i < list.length; ++i) {
      if (list[i].checked) {
        StepThreeList = [...StepThreeList, questionTHREE.qna[i]]; 
      }
    }
  }
  q.style.opacity = "0";
  b.style.display = "flex";
  setTimeout(function() {
    //for now only pass the first from selected group
    ResponseThree = StepThreeList[0];
    progress3.value = "1";
    q.style.display = "none",
    b.style.opacity = "1";
  }, 500);
};

StepTHREE = (id, value) => {
  const q = document.getElementById("quiz-three");
  const n = document.getElementById("next-three-btn");

  if (id != "three-5" && document.getElementById("three-5").checked) {
    document.getElementById(id).checked = false;
  }
  if (id == "three-5" && document.getElementById("three-4").checked || 
      id == "three-5" && document.getElementById("three-3").checked || 
      id == "three-5" && document.getElementById("three-2").checked || 
      id == "three-5" && document.getElementById("three-1").checked ){
    document.getElementById(id).checked = false;
  } 
  if (document.getElementById("three-5").checked ||
      document.getElementById("three-4").checked || 
      document.getElementById("three-3").checked || 
      document.getElementById("three-2").checked || 
      document.getElementById("three-1").checked ){
    n.disabled = false;
  } else {
    n.disabled = true;
    progress3.value = "0";
  }
};

StepFOUR = (id, value) => {
  const q = document.getElementById("quiz-four");
  const b = document.getElementById("quiz-five");
  const n = document.getElementById("next-four-btn");
  if (id != "four-1" && document.getElementById("four-1").checked ||
      id != "four-2" && document.getElementById("four-2").checked ||
      id != "four-3" && document.getElementById("four-3").checked ){ 
    document.getElementById(id).checked = false; 
  } else if (document.getElementById(id).checked) {
    ResponseFour = questionFOUR.qna[value]; 
    n.disabled = false;
    q.style.opacity = "0";
    b.style.display = "flex";
    setTimeout(function() {
      
      progress4.value = "1";
      q.style.display = "none",
      b.style.opacity = "1";
    }, 500);
  } else {
    n.disabled = true;
    progress4.value = "0";
  }
};
StepFIVE = (id, value) => {
  const q = document.getElementById("quiz-five");
  const b = document.getElementById("quiz-six");
  const n = document.getElementById("next-five-btn");
  if (id != "five-1" && document.getElementById("five-1").checked ||
      id != "five-2" && document.getElementById("five-2").checked ||
      id != "five-3" && document.getElementById("five-3").checked ||
      id != "five-4" && document.getElementById("five-4").checked ||
      id != "five-5" && document.getElementById("five-5").checked ){ 
    document.getElementById(id).checked = false; 
  } else if (document.getElementById(id).checked) {
    ResponseFive = questionFIVE.qna[value]; 
    n.disabled = false;
    q.style.opacity = "0";
    b.style.display = "flex";
    setTimeout(function() {   
      progress5.value = "1";
      q.style.display = "none",
      b.style.opacity = "1";
    }, 500);
  } else {
    n.disabled = true;
    progress5.value = "0";
  }
};
StepSIX = (id, value) => {
  const q = document.getElementById("quiz-six");
  const b = document.getElementById("quiz-seven");
  const n = document.getElementById("next-six-btn");

  if (id != "six-1" && document.getElementById("six-1").checked ||
      id != "six-2" && document.getElementById("six-2").checked ||
      id != "six-3" && document.getElementById("six-3").checked ||
      id != "six-4" && document.getElementById("six-4").checked ){ 
    document.getElementById(id).checked = false; 
  } else if (document.getElementById(id).checked) {
    ResponseSix = questionSIX.qna[value]; 
    n.disabled = false;
    q.style.opacity = "0";
    b.style.display = "flex";
    setTimeout(function() {
      
      progress6.value = "1";
      q.style.display = "none",
      b.style.opacity = "1";
    }, 500);
  } else {
    n.disabled = true;
    progress6.value = "0";
  }
};
StepSEVEN = (id, value) => {
  const q = document.getElementById("quiz-seven");
  const b = document.getElementById("quiz-eight");
  const n = document.getElementById("next-seven-btn");

  ResponseSeven = questionSEVEN.qna[value]; 
  
  n.disabled = false;
  setTimeout(function() {
    q.style.opacity = "0";
    b.style.display = "flex";
    setTimeout(function() {
      
      progress7.value = "1";
      q.style.display = "none",
      b.style.opacity = "1";
    }, 500);
  }, 500);
};

let selectedEight = 0;
StepEIGHT = (id, value) => {
  const target = document.getElementById(id);
  const n = document.getElementById("next-eight-btn");

  if (target.checked){
    n.disabled = false;
    selectedEight = ++selectedEight;
    progress8.value = "1";
  } else if (target.checked == false && selectedEight == 1) {
    selectedEight = 0;
    progress8.value = "0";
    n.disabled = true;
 } else {
    selectedEight = --selectedEight;
 }
};
// Question Eight answers are not saved or utilitzed
btnEIGHT = () => {
  const q = document.getElementById("quiz-eight");
  const b = document.getElementById("quiz-nine");
  const p = document.getElementById("progress-container");
  p.style.opacity = "0";
  q.style.opacity = "0";
  b.style.display = "flex";
  quizNine();
    setTimeout(function() {
      progress8.value = "1";
      q.style.display = "none",   
      p.style.display = "none",   
      b.style.opacity = "1";
    }, 500);
};

quizNine = (() => {
  const quizID = document.getElementById("quiz_banner_signup");
  if (quizID){

    quizID.querySelector("div").remove();
    quizID.classList.add("number", `${ResponseSeven.qNum}`);    

    const content = document.createElement("div");
  
    //====> Add Small Header
    const createHeader = document.createElement("h2");
    createHeader.setAttribute("id", 'klaviyo-subscribe-header');
    createHeader.classList.add("form-header");
    let createHeaderText = document.createTextNode(`ENTER YOUR EMAIL TO SEE YOUR RESULTS!`);
    createHeader.appendChild(createHeaderText);

    
      //====> Add subscribe form
      const subscribeWrapper = document.createElement("div");
      subscribeWrapper.setAttribute("id", 'input-wrapper-nine');
      subscribeWrapper.classList.add("form-question");
    
        const createImg = document.createElement("img");
        createImg.setAttribute("id", 'nine-image');
        createImg.src = `${ResponseSeven.image}`;
      subscribeWrapper.appendChild(createImg); 
    
        const createDiv = document.createElement("div");
    
        createDiv.appendChild(createHeader);
    
          let createInputList = document.createElement("input");
          createInputList.setAttribute("type", 'hidden');
          createInputList.setAttribute("name", 'g');
          createInputList.setAttribute("value", 'Uqywym');
        createDiv.appendChild(createInputList);
    
          let createInputFields = document.createElement('input');
          createInputFields.setAttribute("type", 'hidden');
          createInputFields.setAttribute("name", '$fields');
          createInputFields.setAttribute("value", 'body_type');    
        createDiv.appendChild(createInputFields);

          let createInputListFields = document.createElement('input');
          createInputListFields.setAttribute("type", 'hidden');
          createInputListFields.setAttribute("name", '$list_fields');
          createInputListFields.setAttribute("value", 'body_type');    
        createDiv.appendChild(createInputListFields);

      const createInputDiv = document.createElement("div");

      createInputDiv.classList.add('klaviyo_field_group');
    
          let createInputProgram = document.createElement('input');
          createInputProgram.setAttribute("id", 'k_id_bodytype');
          createInputProgram.setAttribute("type", 'hidden');
          createInputProgram.setAttribute("name", 'body_type');
          createInputProgram.setAttribute("value", `${ResponseSeven.response}`);    
        createInputDiv.appendChild(createInputProgram);

          let createInputName = document.createElement('input');
          createInputName.setAttribute("id", 'k_id_fname');
          createInputName.setAttribute("type", 'text');
          createInputName.setAttribute("name", '$first_name');
          createInputName.setAttribute("value", '');  
          createInputName.setAttribute("placeholder", 'First Name*');   
          createInputName.setAttribute('required', '');
        createInputDiv.appendChild(createInputName);
    
          let createInputEmail = document.createElement('input');
          createInputEmail.setAttribute("id", 'k_id_email');
          createInputEmail.setAttribute("type", 'email');
          createInputEmail.setAttribute("name", 'email');
          createInputEmail.setAttribute("value", '');  
          createInputEmail.setAttribute("placeholder", 'E-mail*');   
          createInputEmail.setAttribute("required", '');
        createInputDiv.appendChild(createInputEmail);
      createDiv.appendChild(createInputDiv);
    
        const createSuccessDiv = document.createElement("div");
        createSuccessDiv.setAttribute("id", 'klaviyo-message');
        createSuccessDiv.classList.add('klaviyo_message');
      
          const createSuccess = document.createElement("div");
          createSuccess.setAttribute("id", 'success_k');
          createSuccess.classList.add("success_message");
          createSuccess.style.display = "none";
        createSuccessDiv.appendChild(createSuccess);
    
      createDiv.appendChild(createSuccessDiv);
    
      const createButtonDiv = document.createElement("div");
      createButtonDiv.setAttribute("id", 'klaviyo-submit');
      createButtonDiv.classList.add("klaviyo_form_actions");

       const createKlaviyoButton = document.createElement("button");
        createKlaviyoButton.classList.add("klaviyo_submit_button");
        createKlaviyoButton.setAttribute("type", 'submit');
        createKlaviyoButton.classList.add("custom-button");
        createKlaviyoButton.onclick = function(){return btnNINE()};
          const createKlaviyoButtonSpan = document.createElement("span");
          let createSubscribeText = document.createTextNode(`SUBSCRIBE`);
        createKlaviyoButtonSpan.appendChild(createSubscribeText);
        createKlaviyoButton.appendChild(createKlaviyoButtonSpan);
        createButtonDiv.appendChild(createKlaviyoButton);   
      createDiv.appendChild(createButtonDiv);
    
      subscribeWrapper.appendChild(createDiv);
    
    content.appendChild(subscribeWrapper);
  quizID.appendChild(content);
  }
});

btnNINE = () => {
  const n = document.getElementById("next-nine-btn");

  // Remove header
  const klaviyoSubscribeHeader = document.getElementById("klaviyo-subscribe-header");
  klaviyoSubscribeHeader.style.display = "none";
  
  // Error Message
  const klaviyoMessageBox = document.getElementById("klaviyo-message");
  const createError = document.createElement("div");
  createError.setAttribute("id", 'error_k');
  createError.classList.add("error_message");
  createError.style.display = "none";
  klaviyoMessageBox.appendChild(createError);
  
// Keep checking for success to engage next window  
  setTimeout(() => {
    if (document.getElementById("success_k").style.display != "none"){
      klaviyoMessageBox.style.opacity = "0";
      showResults();
    } else {
      setTimeout(() => {
        if (document.getElementById("success_k").style.display != "none"){
          klaviyoMessageBox.style.opacity = "0";
          showResults();  
        } else {
          setTimeout(() => {
            if (document.getElementById("success_k").style.display != "none"){
              klaviyoMessageBox.style.opacity = "0";
              showResults();
            }
          }, 3000);
        }
      }, 1000);
    }
  }, 1000);
};

quizSuccessResponse = () => {
  // Remove content on successful submit
  // Fade out
  const removeErrorBox = document.getElementById("error_k");
  const submitBtn = document.getElementById("klaviyo-submit");
  const subscribeImg = document.getElementById("nine-image");
  const successK = document.getElementById("success_k");
  
  removeErrorBox.remove();
  submitBtn.style.opacity = 0;
  subscribeImg.style.opacity = 0;
  successK.style.opacity = 0;
  
  setTimeout(() => {
    subscribeImg.style.display = "none";
    successK.style.display = "none"; 
    submitBtn.style.display = "none";
  }, 500);
  
}

//====================================> KLAVIYO - OLD FORM ADDED FROM "Klaviyo Form 7 - not integrated"

quizFinish = () => {
  // ADJUST SIGNUP CONTAINER STYLE TO FIT NEW CONTENT
  const signupContainer = document.getElementById("quiz_banner_signup");
      signupContainer.style.display = "flex";
      signupContainer.style.justifyContent = "center";
      signupContainer.style.alignItems = "center";
  // CREATE THANK YOU RESPONSE AFTER SIGNUP
  const klaviyoMessageBox = document.getElementById("klaviyo-message");

        const createConfirm = document.createElement("div");
            createConfirm.setAttribute("id", 'confirm_k');
            const createConfirmTitle = document.createElement("h2");
                  let createConfirmText = document.createTextNode(`THANK YOU!`);
                  createConfirmTitle.appendChild(createConfirmText);
            createConfirm.appendChild(createConfirmTitle);
            const createConfirmDescription = document.createElement("p");
                createConfirmDescription.classList.add("quiz-complete");
                  let createDescriptionText = document.createTextNode(`I hope this will help you with your choice of program. If you still have any questions, you can always email me at info@momomuscle.com`);
                  createConfirmDescription.appendChild(createDescriptionText);
            createConfirm.appendChild(createConfirmDescription);
        klaviyoMessageBox.prepend(createConfirm);
  
  // REOPEN RESULTS BUTTON
        const reopenResultsBtn = document.createElement("button");
              reopenResultsBtn.setAttribute("id", 'reopen-btn');
              reopenResultsBtn.classList.add("custom-button");
              reopenResultsBtn.setAttribute("type", 'submit');
              reopenResultsBtn.onclick = function(){
                document.getElementById("quiz-response").style.display = "grid";
                document.getElementById("quiz-response").style.marginLeft = "0vw";
                document.getElementById("results-close-btn").style.display = "inline-flex";
                closeBtn.style.display = "inline-flex";
              };
              const createReopenSpan = document.createElement("span");
                    let createReopenText = document.createTextNode(`GO TO RESULTS`);
                    createReopenSpan.appendChild(createReopenText);
              reopenResultsBtn.appendChild(createReopenSpan);
        klaviyoMessageBox.appendChild(reopenResultsBtn);
  
        setTimeout(() => { klaviyoMessageBox.style.opacity = "1"; }, 500);
}

showResults = () => {
  quizSuccessResponse();
  setTimeout(() => {
    quizFinish();
    quizResponse();
    const closeBtn = document.getElementById("results-close-btn");
          closeBtn.style.display = "inline-flex";
  }, 500);
};

closeResultsPage = () => {    
  document.getElementById("quiz-response").style.marginLeft = "200vw";
  setTimeout(()=> { 
    document.getElementById("results-close-btn").style.display = "none"; 
  }, 1000);
  
  const errorKlaviyoBox = document.getElementById("error_k");
  if (errorKlaviyoBox){
    errorKlaviyoBox.style.display = "none";
  }
};